import { useState, useRef } from 'react'
import { SxProps } from '@mui/system'
import { Theme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Grid, { GridSize } from '@mui/material/Grid'
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery'
import Dialog from '@mui/material/Dialog'
import './ImageGallery.css'

type ImageGalleryControlProps = {
    data: Array<ImageGalleryItemType>
    sxProps?: SxProps<Theme>
    gridSize?: {
        xs?: boolean | GridSize
        sm?: boolean | GridSize
        md?: boolean | GridSize
        lg?: boolean | GridSize
    }
    showFullscreenButton?: boolean
    showBullets?: boolean
    autoPlay?: boolean
    showThumbnails?: boolean
    showNav?: boolean
    slideInterval?: number
    additionalClass?: any
    useFullScreen?: boolean
    fullScreenSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const ImageGalleryControl = (props: ImageGalleryControlProps) => {
    const {
        showFullscreenButton = false,
        showBullets = false,
        autoPlay = false,
        showThumbnails = false,
        showNav = false,
        useFullScreen = false,
        fullScreenSize = 'sm',
    } = props
    const refImage = useRef(null)
    const [zoom, setZoom] = useState<boolean>(false)

    const renderItem = (item: ReactImageGalleryItem) => {
        const props = refImage.current as any
        const imgList = props?.props?.items ?? []
        const currentIndex = props?.state?.currentIndex
        return (
            <>
                <button
                    type="button"
                    onClick={() => setZoom((prev) => !prev)}
                    style={{
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: zoom ? 'zoom-out' : 'zoom-in',
                    }}
                >
                    <img src={item.original} alt="" height="300" />
                </button>

                <Dialog fullWidth={true} maxWidth={fullScreenSize} open={zoom} onClose={() => setZoom(false)}>
                    <Box>
                        <button type="button" onClick={() => setZoom((prev) => !prev)}>
                            <img
                                src={imgList?.[currentIndex]?.original ?? ''}
                                alt=""
                                width="100%"
                                style={{
                                    cursor: zoom ? 'zoom-out' : 'zoom-in',
                                }}
                            />
                        </button>
                    </Box>
                </Dialog>
            </>
        )
    }

    return (
        <Box sx={{ height: 300, ...props.sxProps }}>
            <Grid container>
                <Grid item {...props.gridSize}>
                    <ImageGallery
                        ref={refImage}
                        items={props.data}
                        showPlayButton={false}
                        showFullscreenButton={showFullscreenButton}
                        showBullets={showBullets}
                        autoPlay={autoPlay}
                        showThumbnails={showThumbnails}
                        showNav={showNav}
                        slideInterval={props.slideInterval}
                        additionalClass={props.additionalClass}
                        renderItem={useFullScreen ? renderItem : () => <></>}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default ImageGalleryControl
